import { render, staticRenderFns } from "./TotalStatsUsers.container.vue?vue&type=template&id=0faf2fef&scoped=true&"
import script from "./TotalStatsUsers.container.vue?vue&type=script&lang=js&"
export * from "./TotalStatsUsers.container.vue?vue&type=script&lang=js&"
import style0 from "./TotalStatsUsers.container.vue?vue&type=style&index=0&id=0faf2fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf2fef",
  null
  
)

export default component.exports